<section class="hero">
  <div class="row py-lg-5 container">
      <div class="col-md-8 py-5 mx-5">
          <h1 class="text-brand">Welcome to Taniti</h1>
          <h2 class="lead">Where Adventure Meets Tranquility</h2>
          <p>
            <a href="/book" class="btn btn-primary my-2">Book Your Trip</a>
          </p>
      </div>
  </div>
</section>

<section class="container my-5 mx-auto d-flex justify-content-center">
  <div class="col-md-8 text-center">
    <h2>About Taniti</h2>
    <p>
      Taniti is a small, tropical island in the Pacific. While the island has an area of less than
      500 square miles, the terrain is varied and includes both sandy and rocky beaches, a small
      but safe harbor, lush tropical rainforests, and a mountainous interior that includes a small,
      active volcano. Taniti has an indigenous population of about 20,000. Until a recent increase in
      tourism, most the Tanitian economy was dominated by fishing or agriculture.
    </p>
    <p>
      <a href="/about" class="btn btn-primary my-2">Learn More</a>
    </p>
  </div>
</section>
<hr>

<section class="col-md-8 my-5 mx-auto d-flex flex-column justify-content-center">
  <div class="row">
    <h2 class="text-center">Trip Packages Tailored For...</h2>
  </div>

  <app-personas-booking />
</section>

<hr>

<section class="col-md-8 my-5 mx-auto d-flex flex-column justify-content-center categories">
  <h2 class="text-center">Explore Taniti</h2>
  <div class="category-carousel">
    <owl-carousel-o [options]="carouselOptions">
      <ng-container *ngFor="let slide of categories">
        <ng-template carouselSlide [width]="250" [id]="slide.id">
          <div class="card">
            <div [class]="'card-content card-'+slide.id">
              <a [owlRouterLink]="slide.route">
                <h4>{{slide.label}}</h4>
              </a>
            </div>
          </div>
        </ng-template>
      </ng-container>
    </owl-carousel-o>
  </div>
</section>
